import React, { useState } from "react";
import {
	IonButton,
	IonCol,
	IonIcon,
	IonInput,
	IonItem,
	IonLabel,
	IonModal,
	IonRadio,
	IonRadioGroup,
	IonRow,
	IonText,
	IonToast,
	isPlatform,
} from "@ionic/react";

import "../../global.scss";
import "./addVehicle.scss";
import { connect } from "react-redux";

import { chevronBackOutline, chevronForward, searchOutline } from "ionicons/icons";
import {
	ADD_VEHICLE,
	BRAND,
	CONTINUE,
	FUEL_TYPE,
	VARIANT,
	SELECT_VEHICLE_BRAND,
	SELECT_VEHICLE_MODEL_YEAR,
	SELECT_VEHICLE_VARIANT,
	SEARCH_VEHICLE_MODEL_YEAR,
	SEARCH_VEHICLE_VARIANT,
	PLEASE_SELECT_BRAND,
	PLEASE_SELECT_FUEL_TYPE,
	PLEASE_SELECT_MODEL,
	PLEASE_SELECT_VARIANT,
	YEAR,
	MODEL,
	SELECT_YEAR,
	SEARCH_FOR_VEHICLE,
	SEARCH_FOR_BRANDS,
	VARIANT_PLACEHOLDER,
	MODEL_PLACEHOLDER,
	BRAND_PLACEHOLDER,
	VEHICLE_ALREADY_EXISTS,
	VEHICLE_ADDED_SUCCESSFULLY,
	REG_NO,
	REGISTRATION_NUMBER,
	PLEASE_ENTER_REGISTERED_NUMBER,
	PLEASE_ENTER_VALID_REGISTERED_NUMBER,
	CLIENT_NAME,
} from "../../constants";

import SelectVehicleBrands from "./SelectVehicleBrands";
import SelectVehicleModel from "./SelectVehicleModel";
import SelectVariant from "./SelectVariant";

import {
	getBrandsData,
	getModelsData,
	getVariantsData,
	updateEditedUserDetails,
	userVehicles,
	updateOnBoarding,
	saveCatelogVehicleId,
	deleteVariantsData,
} from "../../Store/Actions";
import {
	COLLECTIONS,
	fireStoreDbInstance,
	getDoc,
	saveSubCollectionData,
	updateDoc,
} from "../../firebase";
import { ToastMessage } from "../../utils/toastMessage";
import { alphaAndNumbers, checkMediaQuery, isSplChar } from "../../utils";

const AddVehicle: React.FC = (props: any) => {
	const years = [];
	const thisYear = new Date().getFullYear();
	for (let i = 0; i < 23; i++) {
		years.push(thisYear - i);
	}
	const [selectedFuel, setFuel] = useState("Diesel");
	const [showBrands, setShowBrands] = useState(false);
	const [showModels, setShowModels] = useState(false);
	const [showYear, setShowYear] = useState(false);
	const [showVariant, setShowVariant] = useState(false);
	const [modelId, setModelId] = useState("");
	const [isDisabled, setDisabled] = useState(false);
	const [search, setSearch] = useState({
		brand: "",
		model: "",
		variant: "",
	});
	const [toast, setToast] = useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	const [state, setState] = React.useState({
		make: "",
		model: "",
		modelId: "",
		variant: "",
		fuelType: "",
		catalogVehicleId: "",
		imageUrl: "",
		year: "",
		registrationNumber: "",
	});

	React.useEffect(() => {
		fetchBrandsData();
		return () => {
			setState({
				...state,
				make: "",
				model: "",
				modelId: "",
				variant: "",
				fuelType: "",
				catalogVehicleId: "",
				imageUrl: "",
				year: "",
			});
		};
	}, []);

	const fetchBrandsData = async () => {
		await props.getBrandsData();
	};

	const VehicleBrand = async (make: any, makeId: any) => {
		setState({
			...state,
			make: make,
			model: "",
			modelId: "",
			variant: "",
			fuelType: "",
			catalogVehicleId: "",
			imageUrl: "",
			year: "",
		});
		setShowBrands(!showBrands);
		await props.getModelsData({ makeId: makeId, clientName: CLIENT_NAME });
		setShowModels(!showModels);
	};

	const saveVehicleModelData = (model: any, imageUrl: any, modelId: any) => {
		setState({
			...state,
			model: model,
			modelId: modelId,
			year: "",
			imageUrl,
			fuelType: "",
		});
		setModelId(modelId);
		setShowModels(!showModels);
		setShowYear(!showYear);
	};

	const saveVehicleYear = async (year: any) => {
		setState({
			...state,
			year: year,
			fuelType: "",
		});
		setShowYear(!showYear);
		// setShowVariant(!showVariant);
	};

	const saveVariantData = (catalogVehicleId: any, fuelType: any, name: any) => {
		try {
			if (!!state.fuelType && state.fuelType !== fuelType) {
				throw new Error("Selected variant doesnot match with fuel type");
			}
			setState({
				...state,
				catalogVehicleId: catalogVehicleId,
				fuelType: fuelType,
				variant: name,
			});
			setShowVariant(!showVariant);
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};

	const saveVechicleCollection = async () => {
		try {
			const {
				make = "",
				fuelType = "",
				model = "",
				catalogVehicleId = "",
				registrationNumber = "",
			} = state;
			const db = await fireStoreDbInstance();
			if (make.length === 0) {
				throw Error(PLEASE_SELECT_BRAND);
			}
			if (model.length === 0) {
				throw Error(PLEASE_SELECT_MODEL);
			}
			if (fuelType.length === 0) {
				throw Error(PLEASE_SELECT_FUEL_TYPE);
			}
			if (!registrationNumber.length || !alphaAndNumbers(registrationNumber)) {
				throw Error(
					!registrationNumber.length
						? PLEASE_ENTER_REGISTERED_NUMBER
						: PLEASE_ENTER_VALID_REGISTERED_NUMBER
				);
			}
			if (catalogVehicleId.length === 0) {
				throw Error(PLEASE_SELECT_VARIANT);
			}
			if (
				props.userVehiclesList
					.map((ele: any) => ele.catalogVehicleId)
					.includes(catalogVehicleId)
			) {
				throw Error(VEHICLE_ALREADY_EXISTS);
			}
			setDisabled(true);
			const payload = {
				...state,
				defaultAddressRef: props.defaultAddressRef || "",
				documentIds: [],
			};

			// console.log("234 ======", payload);

			const did: any = await saveSubCollectionData(
				props.uid,
				COLLECTIONS.USERS,
				COLLECTIONS.VECHICLES,
				{
					...payload,
					defaultAddressRef: !!payload.defaultAddressRef ? payload.defaultAddressRef : "",
				},
				"defaultVehicleRef"
			);
			if (!!did && did.success) {
				setToast({
					showToast: true,
					toastMessage: VEHICLE_ADDED_SUCCESSFULLY,
					severity: "success",
				});
			}
			!props.onBoarding && updateOnBoardingStatus();
			props.onBoarding &&
				(await props.userVehicles(
					[
						{
							...payload,
							did: did.did,
							selectedAddressRef: !!payload.defaultAddressRef
								? payload.defaultAddressRef.split("/").pop()
								: "",
						},
					],
					"merge"
				));
			if (props.userVehiclesList.length < 1) {
				await props.updateEditedUserDetails({
					defaultVehicleRef: `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${did.did}`,
					selectedVehicleRef: `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${did.did}`,
				});
				await props.saveCatelogVehicleId(catalogVehicleId);
			}
			setDisabled(false);
			setToast({
				showToast: true,
				toastMessage: VEHICLE_ADDED_SUCCESSFULLY,
				severity: "success",
			});
			setTimeout(() => {
				props.onBoarding && props.history.goBack();
			}, 1000);
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};

	const updateOnBoardingStatus = async () => {
		const data: any = await getDoc(props.uid, COLLECTIONS.USERS);
		await updateDoc(props.uid, { onBoarding: true }, COLLECTIONS.USERS);
		await props.updateOnBoarding({ onBoarding: true });
		props.history.push("/portal");
	};
	const handleKeypressBrands = (e: any, make: any, makeId: any) => {
		if (e.key === "Enter") {
			VehicleBrand(make, makeId);
		}
	};
	const handleKeypressModels = (e: any, model: any, imageUrl: any, modelId: any) => {
		if (e.key === "Enter") {
			saveVehicleModelData(model, imageUrl, modelId);
		}
	};
	const handleKeypressYear = (e: any, ele: any) => {
		if (e.key === "Enter") {
			saveVehicleYear(ele);
		}
	};
	const handleKeypressVariant = (e: any, variant: any, fuelType: any, name: any) => {
		if (e.key === "Enter") {
			saveVariantData(variant, fuelType, name);
		}
	};

	const pressEnterBtn = (e: any, tabName: string) => {
		if (e.key === "Enter") {
			switch (tabName) {
				case "BRANDS":
					return setShowBrands(true);
				case "MODELS":
					return setShowModels(true);
				case "YEARS":
					return setShowYear(true);
				case "VARIANT":
					return setShowVariant(true);
			}
		}
	};

	return (
		<>
			<IonCol className="middle_panle" size-md="6">
				<>
					<div
						className="add_veh_float_header"
						style={{ paddingTop: isPlatform("android") ? 20 : 0 }}
					>
						<div className="personal_details_div_child mg-bottom_22 wholeApp">
							{props.onBoarding && (
								<img
									src={
										checkMediaQuery()
											? "/images/gray_backarrow.svg"
											: "/images/back_arrow.svg"
									}
									className="back_arrow"
									onClick={() => props.history.goBack()}
								/>
							)}
							<IonLabel className="personal_details_labels">{ADD_VEHICLE}</IonLabel>
							<div />
						</div>
					</div>
					<div className="personal_details_text marginT_80 height_100per left_right_padding add_vehicle_heading addVeh_marginTop60 marginTop_searchbar">
						{/* <div className="personal_details_div">
              <div className="name_input_div">
                <IonInput
                  placeholder={SEARCH_FOR_VEHICLE}
                  type="text"
                  className="name_input_icon"
                  color="tertiary"
                />
                <IonIcon icon={searchOutline} className="right_icon" />
                <img src="/images/search.svg" className="mobile-search-icon" />
                
              </div>
            </div> */}

						{/* Registration Number input */}
						<div className="personal_details_div">
							<IonLabel className="name_text email_text mg_top_28">{REG_NO} </IonLabel>
							<IonCol className="text_center_label" size="12">
								<input
									className="manage_reg_no_input_text changePlaceholderColor"
									placeholder={REGISTRATION_NUMBER}
									type="text"
									color="secondary"
									value={!!state.registrationNumber ? state.registrationNumber : ""}
									onChange={(event) => {
										if (!isSplChar(event.target.value)) {
											setState({
												...state,
												registrationNumber: event.target.value,
											});
										}
									}}
								/>
							</IonCol>
						</div>

						<div className="personal_details_div">
							<IonLabel className="name_text email_text mg_top_28">{BRAND}</IonLabel>
							<IonModal
								cssClass="modalOpacity"
								isOpen={showBrands}
								backdropDismiss={true}
								onDidDismiss={() => {
									setSearch({
										brand: "",
										model: "",
										variant: "",
									});
									setShowBrands(false);
								}}
							>
								<div className="modal_body">
									<div className="modal_panel pd_bt_5 header_panel_vehicle padding-right-0">
										<IonText className="modal_header">{SELECT_VEHICLE_BRAND} </IonText>
										<img
											className="close_icon"
											onClick={() => setShowBrands(false)}
											src="/images/close_popup.svg"
										/>
									</div>
									<div className="search_brand margin-left-right-0">
										<IonInput
											className="input_search"
											placeholder={SEARCH_FOR_BRANDS}
											value={search.brand}
											onIonChange={(event: any) =>
												setSearch({
													...search,
													brand: event.detail.value,
												})
											}
										/>
										<img className="search_web" src="/images/search-icon.svg" />
										<img className="search_res" src="/images/search_res.svg" />
									</div>
									<SelectVehicleBrands
										carBrands={
											!!search.brand
												? props.brandsData.filter((ele: any) =>
														ele.name
															.toLowerCase()
															.includes(search.brand.trim().toLowerCase())
												  )
												: props.brandsData
										}
										saveBrandData={(make: any, makeId: any) => VehicleBrand(make, makeId)}
										selectedBrand={state.make}
										handleKeypressBrands={(event: any, make: any, makeId: any) =>
											handleKeypressBrands(event, make, makeId)
										}
									/>
								</div>
							</IonModal>

							<div
								className="name_input_div"
								tabIndex={0}
								onClick={() => setShowBrands(true)}
								onKeyPress={(e: any) => pressEnterBtn(e, "BRANDS")}
							>
								<IonInput
									placeholder={BRAND_PLACEHOLDER}
									type="text"
									className="name_input_icon"
									color="tertiary"
									readonly={true}
									value={state.make}
								/>
								{checkMediaQuery() ? (
									<img src="images/right_arrow_res.svg" className="right_icon_res" />
								) : (
									<img
										src="/images/proile_forward_icon.svg"
										className="profile_forward_icon"
									/>
								)}
							</div>
						</div>
						<div className="personal_details_div">
							<IonLabel className="name_text email_text add_vehicle_res">
								{MODEL}
							</IonLabel>
							<IonModal
								cssClass="modalOpacity"
								isOpen={showModels}
								backdropDismiss={true}
								onDidDismiss={() => {
									setSearch({
										brand: "",
										model: "",
										variant: "",
									});
									setShowModels(false);
								}}
							>
								<div className="modal_body">
									<div className="modal_panel pd_bt_5 header_panel_vehicle padding-right-0">
										<IonText className="modal_header vehicle_header">
											{SELECT_VEHICLE_MODEL_YEAR}{" "}
										</IonText>
										<img
											className="close_icon"
											onClick={() => {
												setShowModels(false);
												setSearch({
													...search,
													model: "",
												});
											}}
											src="/images/close_popup.svg"
										/>
									</div>
									<div className="search_brand margin-left-right-0">
										<IonInput
											className="input_search"
											placeholder={SEARCH_VEHICLE_MODEL_YEAR}
											value={search.model}
											onIonChange={(event: any) =>
												setSearch({
													...search,
													model: event.detail.value,
												})
											}
										/>
										<img className="search_web" src="/images/search-icon.svg" />
										<img className="search_res" src="/images/search_res.svg" />
									</div>
									<SelectVehicleModel
										carModels={props.modelsData}
										saveModelData={(model: any, imageUrl: any, modelId: any) =>
											saveVehicleModelData(model, imageUrl, modelId)
										}
										selectedModel={state.model}
										searchData={search.model}
										brandName={state.make}
										handleKeypressModels={(
											event: any,
											model: any,
											imageUrl: any,
											modelId: any
										) => handleKeypressModels(event, model, imageUrl, modelId)}
									/>
								</div>
							</IonModal>
							<div
								tabIndex={0}
								className="name_input_div"
								onClick={() =>
									!!state.make
										? setShowModels(true)
										: setToast({
												showToast: true,
												toastMessage: "Please select vehicle brand",
												severity: "warning",
										  })
								}
								onKeyPress={(e: any) => pressEnterBtn(e, "MODELS")}
							>
								<IonInput
									placeholder={MODEL_PLACEHOLDER}
									value={state.model}
									type="text"
									className="name_input_icon"
									color="tertiary"
									readonly={true}
								/>
								{checkMediaQuery() ? (
									<img src="images/right_arrow_res.svg" className="right_icon_res" />
								) : (
									<img
										src="/images/proile_forward_icon.svg"
										className="profile_forward_icon"
									/>
								)}
							</div>
						</div>
						<div className="personal_details_div">
							<IonLabel className="name_text email_text add_vehicle_res">{YEAR}</IonLabel>
							<IonModal
								cssClass="modalOpacity"
								isOpen={showYear}
								backdropDismiss={true}
								onDidDismiss={() => {
									setSearch({
										brand: "",
										model: "",
										variant: "",
									});
									setShowYear(false);
								}}
							>
								<div className="modal_body">
									<div className="modal_panel pd_bt_5 header_panel_vehicle padding-right-0">
										<IonText className="modal_header vehicle_header">
											{SELECT_YEAR}{" "}
										</IonText>
										<img
											className="close_icon"
											onClick={() => setShowYear(false)}
											src="/images/close_popup.svg"
										/>
									</div>
									<>
										<IonRow className="brands_div variant_layout mg_top_0 margin-left-right-0">
											<IonRadioGroup value={state.year} className="radio-group">
												{years.map((ele: any, index: any) => (
													<IonCol key={index} size-md="6" size="12">
														<IonItem className="border_bottom" lines="none">
															<IonLabel className="radio_label">{ele}</IonLabel>
															<IonRadio
																mode="md"
																tabIndex={0}
																slot="start"
																value={ele}
																onClick={() => {
																	saveVehicleYear(ele);
																}}
																onKeyPress={(event) => {
																	handleKeypressYear(event, ele);
																}}
																color="primary"
															/>
														</IonItem>
													</IonCol>
												))}
											</IonRadioGroup>
										</IonRow>
									</>
								</div>
							</IonModal>
							<div
								tabIndex={0}
								className="name_input_div"
								onClick={() =>
									!!!state.make
										? setToast({
												showToast: true,
												toastMessage: "Please select vehicle brand",
												severity: "warning",
										  })
										: !!!state.model
										? setToast({
												showToast: true,
												toastMessage: "Please select vehicle model",
												severity: "warning",
										  })
										: setShowYear(true)
								}
								onKeyPress={(e: any) => pressEnterBtn(e, "YEARS")}
							>
								<IonInput
									placeholder={SELECT_YEAR}
									value={state.year}
									type="text"
									className="name_input_icon"
									color="tertiary"
									readonly={true}
								/>
								{checkMediaQuery() ? (
									<img src="images/right_arrow_res.svg" className="right_icon_res" />
								) : (
									<img
										src="/images/proile_forward_icon.svg"
										className="profile_forward_icon"
									/>
								)}
							</div>
						</div>
						<div className="select_fields">
							<IonLabel className="label_text mg_top_10" color="secondary">
								{FUEL_TYPE}
							</IonLabel>
						</div>
						<div className="gender_label">
							{[
								{ name: "Petrol", id: "PETROL" },
								{ name: "Diesel", id: "DIESEL" },
								{ name: "CNG", id: "CNG" },
							].map((ele) => (
								<div
									tabIndex={0}
									className="gender_label_child "
									style={{
										backgroundColor: state.fuelType === ele.id ? "#428ee2" : "white",
									}}
									onClick={async () => {
										if (!!modelId && !!state.year) {
											setState({
												...state,
												fuelType: ele.id,
												variant: "",
												catalogVehicleId: "",
											});
											const response = await props.getVariantsData({
												modelId: modelId,
												year: state.year,
												fuelType: ele.id,
												clientName: CLIENT_NAME,
											});
											if (!response) {
												props.deleteVariantsData();
											}
										} else {
											setToast({
												showToast: true,
												toastMessage: "Please select vehicle brand and year",
												severity: "warning",
											});
										}
									}}
									key={ele.id}
								>
									<IonLabel
										className="gender_label_text"
										style={{
											color: state.fuelType === ele.id ? "white" : "#999999",
										}}
									>
										{ele.name}
									</IonLabel>
								</div>
							))}
						</div>
						<div className="personal_details_div">
							<IonLabel className="name_text email_text mg_top_20" color="secondary">
								{VARIANT}
							</IonLabel>
							<IonModal
								cssClass="modalOpacity"
								isOpen={showVariant}
								backdropDismiss={true}
								onDidDismiss={() => {
									setSearch({
										brand: "",
										model: "",
										variant: "",
									});
									setShowVariant(false);
								}}
							>
								<div className="modal_body">
									<div className="modal_panel pd_bt_5 header_panel_vehicle padding-right-0">
										<IonText className="modal_header vehicle_header">
											{SELECT_VEHICLE_VARIANT}{" "}
										</IonText>
										<img
											className="close_icon"
											onClick={() => setShowVariant(false)}
											src="/images/close_popup.svg"
										/>
									</div>
									<div className="search_brand margin-left-right-0">
										<IonInput
											className="input_search"
											placeholder={SEARCH_VEHICLE_VARIANT}
											value={search.variant}
											onIonChange={(event: any) =>
												setSearch({
													...search,
													variant: event.detail.value,
												})
											}
										/>
										<img className="search_web" src="/images/search-icon.svg" />
										<img className="search_res" src="/images/search_res.svg" />
									</div>
									<SelectVariant
										vehicleVariant={
											!!state.make
												? props.variantsData.filter(
														(ele: any) =>
															ele.make === state.make && ele.model === state.model
												  )
												: []
										}
										saveVehicleVariant={(variant: any, fuelType: any, name: any) => {
											saveVariantData(variant, fuelType, name);
										}}
										selectedVariant={state.catalogVehicleId}
										searchData={search.variant}
										handleKeypressVariant={(
											event: any,
											variant: any,
											fuelType: any,
											name: any
										) => handleKeypressVariant(event, variant, fuelType, name)}
									/>
								</div>
							</IonModal>
							<div
								tabIndex={0}
								className="name_input_div"
								onClick={() =>
									!!!state.make
										? setToast({
												showToast: true,
												toastMessage: "Please select vehicle brand",
												severity: "warning",
										  })
										: !!!state.model
										? setToast({
												showToast: true,
												toastMessage: "Please select vehicle model",
												severity: "warning",
										  })
										: !!!state.fuelType
										? setToast({
												showToast: true,
												toastMessage: "Please select fuel Type",
												severity: "warning",
										  })
										: setShowVariant(true)
								}
								onKeyPress={(e: any) => pressEnterBtn(e, "VARIANT")}
							>
								<IonInput
									placeholder={
										!!state.catalogVehicleId
											? `${state.make} ${state.model} ${state.variant}`
											: VARIANT_PLACEHOLDER
									}
									type="text"
									className={
										!!state.catalogVehicleId
											? "name_input_icon variant_placeholder"
											: "name_input_icon"
									}
									color="tertiary"
									readonly={true}
								/>
								{checkMediaQuery() ? (
									<img src="images/right_arrow_res.svg" className="right_icon_res" />
								) : (
									<img
										src="/images/proile_forward_icon.svg"
										className="profile_forward_icon"
									/>
								)}
							</div>
						</div>
						{/* <div className="btn_parent_div">
              <IonButton
                color="primary"
                className="continue_btn child_btn res_btn_align"
                disabled={isDisabled}
                onClick={() => saveVechicleCollection()}
              >
                {CONTINUE}
              </IonButton>
            </div> */}
					</div>
					<div
						className="btn_parent_div add_veh_continue_float"
						style={{
							marginRight: 25,
							marginLeft: 25,
							width: "-webkit-fill-available",
						}}
					>
						<IonButton
							color="primary"
							className="continue_btn child_btn res_btn_align"
							disabled={isDisabled}
							onClick={() => saveVechicleCollection()}
							style={{
								marginBottom: 30,
								minWidth: "auto",
								width: "100%",
								maxWidth: checkMediaQuery() ? "none" : 320,
							}}
						>
							{CONTINUE}
						</IonButton>
					</div>
				</>
				<ToastMessage
					showToast={toast.showToast}
					ToastMessage={toast.toastMessage}
					severity={toast.severity}
					onDidDismiss={() => {
						setToast({
							showToast: false,
							toastMessage: "",
							severity: "",
						});
					}}
				/>
			</IonCol>
		</>
	);
};
export default connect(
	({
		auth,
		addVehicles: { brandsData, modelsData, variantsData },
		userInfo: { userVehiclesList },
	}: any) => {
		return { ...auth, brandsData, modelsData, variantsData, userVehiclesList };
	},
	{
		getBrandsData,
		getModelsData,
		getVariantsData,
		updateEditedUserDetails,
		userVehicles,
		updateOnBoarding,
		saveCatelogVehicleId,
		deleteVariantsData,
	}
)(AddVehicle);
